/**
 * Normalizes batch API responses (BatchUpsertResultDTO).
 */
export const normalizeBatchUpsertResult = (rawData) => ({
  resourceType: rawData?.resourceType ?? rawData?.resource_type ?? null,
  totalRows: Number(rawData?.totalRows ?? rawData?.total_rows ?? 0),
  created: Number(rawData?.created ?? 0),
  updated: Number(rawData?.updated ?? 0),
  failed: Number(rawData?.failed ?? 0),
  watchlistLinked: Number(rawData?.watchlistLinked ?? rawData?.watchlist_linked ?? 0),
  errors: Array.isArray(rawData?.errors) ? rawData.errors : [],
  failures: Array.isArray(rawData?.failures) ? rawData.failures : [],
});
